import { LinkStoryblok, StoryblokComponent } from '@/types/types-storyblok';
import { usePathname } from 'next/navigation';
import Image from 'next/image';
import clsx from 'clsx';
import type { KeyboardEvent } from 'react';
import { isExternalLink, resolveWebLink } from '@/storyblok/utils/link';
import Link from 'next/link';
import { StoryblokStory } from 'storyblok-generate-ts';
import { isSelectedLink } from '@/app/_components/headerSeo/utils';

type NavItemProps = {
  link: LinkStoryblok;
  isVisible: boolean;
  onLinkKeyDown: (e: KeyboardEvent) => void;
  story: StoryblokStory<StoryblokComponent>;
  component: StoryblokComponent;
};

export const NavItem = ({ link, isVisible, onLinkKeyDown, story, component }: NavItemProps) => {
  const pathName = usePathname();
  const isSelected = isSelectedLink(pathName as string, link);
  const icon = link.icon;
  const hasIcon = icon && icon.filename;
  const LinkEl = link.link && isExternalLink(link.link) ? 'a' : Link;
  return (
    <li className="w-full" key={link._uid} role="menuitem">
      {link.link && (
        <LinkEl
          data-external={isExternalLink(link.link)}
          aria-hidden={!isVisible}
          aria-current={isSelected ? 'page' : undefined}
          tabIndex={!isVisible || isSelected ? -1 : undefined}
          className={clsx(
            'flex items-center justify-start gap-x-2 transition-colors hover:text-black focus:text-black',
            isSelected ? 'text-black' : 'text-[#6B7280]',
          )}
          href={resolveWebLink(link.link, { story, component })}
          onKeyDown={onLinkKeyDown}
        >
          {isSelected && !hasIcon && <div className="h-2.5 w-2.5 flex-shrink-0 rounded-full bg-elty-green" />}
          {hasIcon && (
            <Image
              className={clsx('h-5 w-5 flex-shrink-0', !isSelected && 'opacity-70')}
              src={icon?.filename}
              alt={icon?.alt ?? ''}
              width={20}
              height={20}
            />
          )}
          <span>{link.title}</span>
        </LinkEl>
      )}
    </li>
  );
};
